import * as Sentry from "@sentry/angular";
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

Sentry.init({
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false
    }),
    Sentry.replayCanvasIntegration()
  ],
  sampleRate: 0.5,
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 0.01,
  replaysOnErrorSampleRate: 0.5,
  enableLogs: true,
  sendDefaultPii: false,
  ...environment.sentry
});

if (environment.production) {
  enableProdMode();
}

if (environment.tracking) {
  // add Google Analytics script to <head>
  const gtmScript = document.createElement('script');
  gtmScript.src = 'assets/scripts/load_gtm.js';
  document.head.appendChild(gtmScript);

  if (!environment.vendor) {
    const iabTcfScript = document.createElement('script');
    iabTcfScript.src = 'assets/scripts/TCF_stub_code.js';
    document.head.appendChild(iabTcfScript);

    // add Trustarc script to body
    const divConsent = document.createElement('div');
    divConsent.id = 'teconsent';
    const divConsentBar = document.createElement('div');
    divConsentBar.id = 'consent_blackbar';

    const trustarcScript = document.createElement('script');
    trustarcScript.async = true;
    trustarcScript.src =
      '//consent.trustarc.com/notice?domain=castorama-fr-iab.com&c=teconsent&text=true&language=fr&pcookie&js=nj&noticeType=bb';

    document.body.appendChild(divConsent);
    document.body.appendChild(trustarcScript);
    document.body.appendChild(divConsentBar);
  }
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));